import { useAuth, useMasterData, useTimeZone } from 'hooks';
import { AppointmentsWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { handleAppointmentsWebSocketMessage } from './handlers/appointmentsMessageHandler';
import { useActionCableChannel } from './useActionCableChannel';

const AppointmentsWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const timeZone = useTimeZone();
    const masterData = useMasterData();
    const dispatch = useDispatch();

    const onReceived = useCallback(
        (message: AppointmentsWebSocketsMessage) => {
            handleAppointmentsWebSocketMessage(message, dispatch, masterData, timeZone);
        },
        [dispatch, masterData, timeZone]
    );

    useActionCableChannel<AppointmentsWebSocketsMessage>({
        channel: 'AppointmentsChannel',
        params: {
            marketplace_id: auth.marketplaceId,
            address_id: auth.addressId
        },
        enabled: Boolean(auth.signedIn && auth.marketplaceId && auth.addressId),
        onReceived,
        subscriptionDeps: [auth.marketplaceId, auth.addressId],
        logLabel: 'AppointmentsWebSockets'
    });

    return null;
};

export default AppointmentsWebSockets;
